/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipes_No_Results_BodyInputs */

const en_recipes_no_results_body = /** @type {(inputs: Recipes_No_Results_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try another word or fewer filters.`)
};

const de_recipes_no_results_body = /** @type {(inputs: Recipes_No_Results_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versuch ein anderes Wort oder weniger Filter.`)
};

/**
* | output |
* | --- |
* | "Try another word or fewer filters." |
*
* @param {Recipes_No_Results_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipes_no_results_body = /** @type {((inputs?: Recipes_No_Results_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipes_No_Results_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipes_no_results_body(inputs)
	return en_recipes_no_results_body(inputs)
});